export const tr = {
    'less-then-min-limit': 'Maksimum harcama {minLimit}% değerinin altında olamaz',
    'limit-must-be-set':
        'Maksimum harcama belirlemeniz gerekiyor: {minLimit} ile {maxLimit} arasında bir tam sayı girin',
    'more-then-max-limit': 'Maksimum harcama en fazla %{maxLimit} olabilir',
    'unavailable-goal': 'Seçilen hedef kullanılamıyor'
};
